import { faFolder, faLaptop, faRss } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import ChooseLeftDetails from './ChooseLeftDetails';

const chooseLeftData = [
    {
     id:1,
     icon:faLaptop,
     title:"FRESH & INNOVATIVE IDEAS",
     description:"Trying to think up new ideas is a counter-intuitive process. Do you ever notice that the harder you look for it, the harder it is to find? It’s incredibly frustrating when you focus your mental energy on trying to find that one insight. You spend hours, days, or even weeks trying to find the solution to an issue."
    },
    {
        id:2,
        icon:faRss,
        title:"GOAL-ORIENTED EXECUTIONS",
        description:"Our model of goals infinite executions, as first introduced in captured many natural goals for communication. This framework only captured goals that could be modeled as the user trying to reach a certain state of the environment by communicating with us."
    },
    {
        id:3,
        icon:faFolder,
        title:"FRESH & INNOVATIVE IDEAS",
        description:"Trying to think up new ideas is a counter-intuitive process. Do you ever notice that the harder you look for it, the harder it is to find? It’s incredibly frustrating when you focus your mental energy on trying to find that one insight. You spend hours, days, or even weeks trying to find the solution to an issue."
     },
]

const ChooseLeft = () => {
    
    return (
        <div>
            {
                chooseLeftData.map(data=> <ChooseLeftDetails key={data.id} data={data}/>)
            }
        </div>
    );
};

export default ChooseLeft;